import { render, staticRenderFns } from "./CourseConfig.vue?vue&type=template&id=65165c35&scoped=true"
import script from "./CourseConfig.vue?vue&type=script&lang=js"
export * from "./CourseConfig.vue?vue&type=script&lang=js"
import style0 from "./CourseConfig.vue?vue&type=style&index=0&id=65165c35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65165c35",
  null
  
)

export default component.exports